import React, { useState, useRef, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiUser, FiLogOut } from "react-icons/fi";
import { Menu } from "lucide-react";
import { auth } from "../firebase";
import { signOut } from "firebase/auth";

const pageNames = {
  "/": "User Management",
  "/ChangePassword": "Change Password",
  "/recipe-management": "Recipe Management",
  "/add-user": "Add New User",
  // ...aur routes add karen agar zarurat ho
};

const Navbar = ({ setSidebarOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const pageTitle = pageNames[location.pathname] || "Admin Panel";
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      localStorage.removeItem("isLocalAdmin");
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <header className="px-6 py-4 flex items-center justify-between bg-gradient-to-r from-primary to-gradientTo shadow-md rounded-b-2xl">
      {/* Hamburger menu for mobile/tablet */}
      <button
        className="lg:hidden mr-3 p-2 flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary transition hover:bg-primary/10 "
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <Menu className="w-7 h-7 text-white" />
      </button>
      <h1 className="text-lg sm:text-xl md:text-2xl font-bold flex-1 truncate max-w-[60vw] md:max-w-none text-white drop-shadow-sm">
        {pageTitle}
      </h1>
      <div className="relative" ref={dropdownRef}>
        <button
          className={`p-1 rounded-full transition shadow-md hover:scale-110 focus:outline-none focus:ring-2 focus:ring-primary bg-white border-2 border-primary/20`}
          onClick={() => setDropdownOpen((prev) => !prev)}
          aria-label="Profile"
          style={{ transition: "all 0.18s cubic-bezier(.4,2,.6,1)" }}
        >
          <img
            src="https://randomuser.me/api/portraits/men/32.jpg"
            alt="Profile"
            className="h-8 w-8 sm:h-9 sm:w-9 rounded-full object-cover border-2 border-primary/40 transition-all duration-200"
          />
        </button>
        {dropdownOpen && (
          <div className="absolute right-0 mt-2 w-44 sm:w-52 bg-white border border-primary/20 rounded-2xl shadow-2xl z-50 animate-fade-in overflow-hidden">
            <div className="py-2">
              <Link to="/ChangePassword">
                <button className="w-full flex items-center gap-3 text-[#e76f51] text-left px-4 sm:px-5 py-2 sm:py-3 hover:bg-[#ffbfae] transition font-semibold focus:bg-[#ffbfae] text-xs sm:text-sm" >
                  <span className="bg-[#ffbfae] p-2 rounded-full">
                    <FiUser className="text-[#e76f51] text-base" />
                  </span>{" "}
                  Change Password
                </button>
              </Link>
              <button
                onClick={handleLogout}
                className="w-full flex items-center gap-3 text-[#e76f51] text-left px-4 sm:px-5 py-2 sm:py-3 hover:bg-[#ffbfae] transition font-semibold focus:bg-[#ffbfae] text-xs sm:text-sm"
              >
                <span className="bg-[#ffbfae] p-2 rounded-full">
                  <FiLogOut className="text-[#e76f51] text-base" />
                </span>{" "}
                Logout
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Navbar;


